import styled from '@emotion/styled'
import { motion } from 'motion/react'

export const SOnboardingModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  overflow-x: hidden;
`

export const SOnboardingModalIllustration = styled(motion.img)`
  height: 16.25rem;
  max-width: 100%;
  object-fit: contain;
`
